<div class="image-gallery-container">
    @if (imageObject) {
        <div class="image-container">
            <img [src]="imageObject[currentIndex].image" class="image" alt="Image {{ currentIndex + 1 }}">
            <button
                class="btn-360"
                *ngIf="currentIndex === 0 && show360View && productDetail.modelQuantityJson"
                mat-stroked-button
                color="primary"
                (click)="popUP360(currentIndex)"
            >
            <mat-icon svgIcon="view360" class="icon"></mat-icon>
            <span class="btn-text">
                360° View
            </span>
            </button>
        </div>  
    
        <div class="carousel-dots">
            <span
                *ngFor="let image of imageObject; let i = index"
                class="carousel-dot"
                [class.active]="i === currentIndex"
                (click)="goToImage(i)"
            >
            </span>
        </div>
    
        <div class="slider-container">
            @for (item of imageObject; let i = $index; track i) {
                <div class="image-container" [ngClass]="{ activeImage: i === currentIndex, dull: i === 0 }" (click)="goToImage(i)">
                    <img [src]="item.thumbImage" class="image" alt="Image {{ $index + 1 }}">
                </div>
            }
        </div>
    }
</div>
